module.exports = __webpack_public_path__ + "static/media/Fae5.d209ccab.png";